import { ChangeEvent } from 'react';
import { SxProps, TablePagination, Theme } from '@mui/material';

import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (nextPage: number) => void;
  onRowsPerPageChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  sx?: SxProps<Theme>;
};

const baseSx: SxProps<Theme> = {
  borderTop: 0,
  height: '42px',
  overflow: 'hidden',
  '.MuiTablePagination-selectLabel': { mt: 0, mb: 0 },
  '.MuiTablePagination-displayedRows': { mt: 0, mb: 0 },
  '.MuiTablePagination-actions': { ml: 0 },
};

// MUI's default spacing doesn't fit a phone-width card, which clips the total count and the
// page arrows, so drop the "Rows per page" label and the toolbar gutters on small screens.
const mobileSx: SxProps<Theme> = {
  '.MuiTablePagination-toolbar': { pl: 0, pr: 0 },
  '.MuiTablePagination-spacer': { display: 'none' },
  '.MuiTablePagination-selectLabel': { display: 'none' },
  '.MuiTablePagination-input': { ml: 0, mr: 1 },
  '.MuiTablePagination-displayedRows': { whiteSpace: 'nowrap' },
  '.MuiTablePagination-actions': { ml: 0, flexShrink: 0 },
  '.MuiTablePagination-actions .MuiIconButton-root': { p: '6px' },
};

export const CursorTablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  sx,
}: Props) => {
  const isMobile = useResponsive('down', 'md');

  return (
    <TablePagination
      component={'div'}
      sx={[baseSx, isMobile && mobileSx, ...(Array.isArray(sx) ? sx : [sx])]}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={(_event: unknown, nextPage) => onPageChange(nextPage)}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};
